export const titleCase = (text) => text?.replace(
  /\w\S*/g,
  (w) => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase(),
);
